import * as React from "react";
const Search = (props) => (
  <svg
    width={21}
    height={21}
    viewBox="0 0 21 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M9.97673 17.8643C14.349 17.8643 17.8934 14.3199 17.8934 9.94767C17.8934 5.57542 14.349 2.03101 9.97673 2.03101C5.60447 2.03101 2.06006 5.57542 2.06006 9.94767C2.06006 14.3199 5.60447 17.8643 9.97673 17.8643Z"
      stroke="#FF6A4B"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18.7267 18.6977L17.0601 17.031"
      stroke="#FF6A4B"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default Search;
